<script>
/**
 * Entry de /store: plantilla sdn-default (storefront) para todos los ecommerce.
 */
export default {
  name: "StoreHomeEntry",
  components: {
    StorefrontView: () => import("@/storefront/StorefrontView"),
  },
  render(h) {
    return h("StorefrontView");
  },
};
</script>
